// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"c04a3387","239":"155089eb","667":"c18e744b"}[chunkId] + ".chunk.js";
};